module.exports = {"210905001":"清河街道","210905004":"新北街道","210905101":"河西镇","210905102":"乌龙坝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210905.json
// module id = 655
// module chunks = 0